<div class="trends-description-row" *ngIf="!isAccountLevel && !trendsSummaryQuestionDropdownVisible">
    <span class="ltms-description trends-top-header-text">{{ mainDiscription }}</span>
    <app-score-comparison-toggle
        class="trends-comparison-wrap"
        [visible]="isComparisonAvailable"
        [showComparisonFlag]="showComparisonFlag"
        [dateType]="dateType"
        [showDescription]="true"
        [checkboxId]="'scoreTrendsComparisonCheckbox'"
        (showComparisonChange)="onShowComparisonChange($event)">
    </app-score-comparison-toggle>
</div>
<div class="ltms-description" *ngIf="!isAccountLevel && trendsSummaryQuestionDropdownVisible">{{ mainDiscription }}</div>
<div class="trends-top-header" *ngIf="isAccountLevel || trendsSummaryQuestionDropdownVisible" [ngClass]="{'trends-top-header-account': isAccountLevel}">
    <div class="trends-summary-question-row" *ngIf="trendsSummaryQuestionDropdownVisible && !isAccountLevel">
        <div class="filter-title">View by</div>
        <app-score-dropdown-menu
            [config]="trendsSummaryQuestionDropdown.config"
            [selectedOption]="trendsSummaryQuestionDropdown.selectedOption"
            [options]="trendsSummaryQuestionDropdown.options"
            (selectedOptionChange)="onTrendsSummaryQuestionSelected($event)">
        </app-score-dropdown-menu>
        <span class="selected-option">{{ trendsQuestionSelected }}</span>
        <div class="tab-comparison-right">
            <app-score-comparison-toggle
                class="trends-comparison-wrap"
                [visible]="isComparisonAvailable"
                [showComparisonFlag]="showComparisonFlag"
                [dateType]="dateType"
                [showDescription]="true"
                [checkboxId]="'scoreTrendsComparisonCheckbox'"
                (showComparisonChange)="onShowComparisonChange($event)">
            </app-score-comparison-toggle>
        </div>
    </div>
    <app-score-comparison-toggle
        *ngIf="isAccountLevel"
        class="trends-comparison-wrap"
        [visible]="isComparisonAvailable"
        [showComparisonFlag]="showComparisonFlag"
        [dateType]="dateType"
        [showDescription]="true"
        [checkboxId]="'scoreTrendsComparisonCheckbox'"
        (showComparisonChange)="onShowComparisonChange($event)">
    </app-score-comparison-toggle>
</div>
<div class="main-container">
    <div class="lhsBox">
        <div [ngClass]="{'overlay': fullScreenComponent === 'drillDownTable'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent === 'drillDownTable'}">
                <div class="card">
                    <div class="filter">
                        <div>
                            <div class="card-name">Score</div>
                            <div class="ltms-description">{{ scoreDiscription }}</div>
                        </div>
                        <span class="other-filters">
                            <span class="viewByText">View by</span>
                            <app-score-dropdown-menu #viewTypeDropdownMenu [ngbTooltip]="viewTypeDropdown.config.isDisabled ? 'No cohorts configured.' : null" [config]="viewTypeDropdown.config" [selectedOption]="viewTypeDropdown['selectedOption']" [options]="viewTypeDropdown.options" (selectedOptionChange)="onOptionChange($event, 'viewType')"></app-score-dropdown-menu>
                            <app-score-widget [fullScreenButtonControl]="isFullScreen" [ngStyle]="{'margin-left': '12px'}" [config]="scoreWidget('drilldown')" (onFullscreenClick)="onFullScreen($event, 'drillDownTable')" (onDownloadClick)="onDownload('drillDownTable')"></app-score-widget>
                        </span>
                    </div>
                    <div class="lhsBoxLoader" *ngIf="lhsBoxLoader">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="lhsBoxLoader" *ngIf="!lhsBoxLoader && lhsBoxError">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <app-score-table *ngIf="!lhsBoxLoader && !lhsBoxError" [selectedRowHighlight]="true" [selectedRowId]="textHighLightId" [tableColumns]="overallTable.header" [tableData]="overallTable.row" [tablePlugins]="trendsTablePlugins" [showDeviation]="showComparisonFlag" [deviationComparisonLabel]="comparisonPeriodLabel" [isTrendsTable]="true" [isMaximized]="fullScreenComponent === 'drillDownTable'" (onTextClickCall)="updateChart($event, 'overallTable')"></app-score-table>
                    <div class="lhsBoxLoader" *ngIf="!lhsBoxLoader && hierarchyTableLoader && isHierarchyTableVisible">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="lhsBoxLoader" *ngIf="(!isAccountLevel && !lhsBoxLoader && !hierarchyTableLoader && hierarchyTableError && isHierarchyTableVisible) || (isAccountLevel && subAccountTable.row.length <= 0 && !lhsBoxLoader && !hierarchyTableLoader && hierarchyTableError && isHierarchyTableVisible)">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <app-score-table *ngIf="!hierarchyTableLoader && subAccountTable.row.length" [selectedRowHighlight]="true" [selectedRowId]="textHighLightId" [ngStyle]="{'margin-top': '12px'}" [tableColumns]="subAccountTable.header" [tableData]="subAccountTable.row" [tablePlugins]="trendsTablePlugins" [showDeviation]="showComparisonFlag" [deviationComparisonLabel]="comparisonPeriodLabel" [isTrendsTable]="true" [isMaximized]="fullScreenComponent === 'drillDownTable'" (onDrillDownClick)="onDrillDownClick($event, 'subAccountTable')" (onTextClickCall)="updateChart($event, 'subAccountTable')"></app-score-table>
                    <app-score-table *ngIf="!hierarchyTableLoader && !hierarchyTableError && isHierarchyTableVisible" [selectedRowHighlight]="true" [selectedRowId]="textHighLightId" [ngStyle]="{'margin-top': '12px'}" [tableColumns]="hierarchyTable.header" [tableData]="hierarchyTable.row" [tablePlugins]="trendsTablePlugins" [showDeviation]="showComparisonFlag" [deviationComparisonLabel]="comparisonPeriodLabel" [isTrendsTable]="true" [isMaximized]="fullScreenComponent === 'drillDownTable'" (onDrillDownClick)="onDrillDownClick($event, 'hierarchyTable')" (onTextClickCall)="updateChart($event, 'hierarchyTable')"></app-score-table>
                </div>
            </div>
        </div>
    </div>
    <div class="rhsBox">
        <div [ngClass]="{'overlay': fullScreenComponent === 'lineChart'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent === 'lineChart'}">
                <div class="card">
                    <div class="filter">
                        <div>
                            <div class="card-name">{{ lineChartDisplayName }} Trend • {{ chartName }}</div>
                            <div class="ltms-description">{{ scoreTrendsDiscription }}</div>
                        </div>
                        <span class="other-filters">
                            <app-score-widget [fullScreenButtonControl]="isFullScreen" [ngStyle]="{'margin-left': '12px'}" [config]="scoreWidget('lineChart')" (onFullscreenClick)="onFullScreen($event, 'lineChart')" (onDownloadClick)="onDownload('lineChart')" (onTrendClick)="onTrendChange($event, 'lineChart')"></app-score-widget>                            
                        </span>
                    </div>
                    <div class="lineChartLoader" *ngIf="lineChartLoader">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="lineChartLoader" *ngIf="!lineChartLoader && lineChartError">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <div class="chart" *ngIf="!lineChartLoader && !lineChartError">
                        <app-score-line-chart [chartPlugins]="lineChartPlugins" [chartData]="lineChartData" (onGraphDataPointClick)="onGraphDataPointClick($event, 'lineChart', '')"></app-score-line-chart>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="{'overlay': fullScreenComponent === 'barChart'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent === 'barChart'}">
                <div class="card">
                    <div class="filter">
                        <div>
                            <div class="card-name">Response Trend • {{ chartName }}</div>
                            <div class="ltms-description">{{ responseTrendDiscription }}</div>
                        </div>
                        <span class="other-filters">
                            <app-score-widget [fullScreenButtonControl]="isFullScreen" [ngStyle]="{'margin-left': '12px'}" [config]="scoreWidget('barChart')" (onFullscreenClick)="onFullScreen($event, 'barChart')" (onDownloadClick)="onDownload('barChart')" (onTrendClick)="onTrendChange($event, 'barChart')" (onChartTypeChange)="onBarChartTypeChange($event)"></app-score-widget>
                        </span>
                    </div>
                    <div class="chart barGraphLoader" *ngIf="barChartLoader" [ngStyle]="{'height': '255px'}">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="chart barGraphLoader" *ngIf="!barChartLoader && barChartError" [ngStyle]="{'height': '255px'}">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <div class="chart barGraph" *ngIf="!barChartLoader && !barChartError">
                        <app-score-bar-chart [chartPlugins]="barChartPlugins" [chartData]="barChartData" (onGraphDataPointClick)="onGraphDataPointClick($event, 'barChart', '')"></app-score-bar-chart>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="{'overlay': fullScreenComponent === 'performerType'}" (click)="$event.target === $event.currentTarget && onOverlayClick()">
            <div [ngClass]="{'content': fullScreenComponent === 'performerType'}">
                <div class="card" *ngIf="performerTypeDropdown.options.length > 0">
                    <div class="filter">
                        <div>
                            <div class="card-name">Top and Bottom Performers - {{ performerTypeDropdownSelectedName }}</div>
                            <div class="ltms-description">{{ topandBottomPerformers }}</div>
                        </div>
                        <span class="other-filters">
                            <span class="viewByText">Cohorts</span>
                            <app-score-dropdown-menu [config]="performerTypeDropdown.config" [selectedOption]="performerTypeDropdown['selectedOption']" [options]="performerTypeDropdown.options" (selectedOptionChange)="onOptionChange($event, 'performerChart')"></app-score-dropdown-menu>
                            <app-score-widget [fullScreenButtonControl]="isFullScreen" [ngStyle]="{'margin-left': '12px'}" [config]="scoreWidget('drilldown')" (onFullscreenClick)="onFullScreen($event, 'performerType')" (onDownloadClick)="onDownload('performerType')"></app-score-widget>
                        </span>
                    </div>
                    <div class="performers-button-box">
                        <div class="performers-button" [ngClass]="{active: isTopPerformers}" (click)="onPerformerButtonClick('topPerformer')">
                            <span><img class="top-perfomer-img" [ngStyle]="{opacity: isTopPerformers ? '1' : ''}" [src]="isTopPerformers ? 'assets/images/thumbs-up.svg' : 'assets/images/thumbs-up-outline.svg'"></span>
                            <span>Top performers</span>
                        </div>
                        <div class="performers-button" [ngClass]="{active: isBottomPerformers}" (click)="onPerformerButtonClick('bottomPerformer')">
                            <span><img class="bottom-perfomer-img" [ngStyle]="{opacity: isBottomPerformers ? '1' : ''}" [src]="isBottomPerformers ? 'assets/images/thumbs-down.svg' : 'assets/images/thumb-down-outline.svg'"></span>
                            <span>Bottom performers</span>
                        </div>
                    </div>
                    <div class="perfomerChartLoader" *ngIf="perfomerChartLoader">
                        <app-ltms-loader></app-ltms-loader>
                    </div>
                    <div class="perfomerChartLoader" *ngIf="!perfomerChartLoader && perfomerChartError">
                        <app-ltms-error [code]="'404'"></app-ltms-error>
                    </div>
                    <div class="performerMainChartWrapper" *ngIf="!perfomerChartLoader && !perfomerChartError">
                        <app-score-drilldown-bar-chart [chartData]="performerChartData" (onGraphDataPointClick)="onGraphDataPointClick($event, 'performerChartData', null)"></app-score-drilldown-bar-chart>
                    </div> 
                    <div class="drilldownChartCard" *ngIf="drilldownChartCache.length > 0">
                        <div *ngFor="let data of drilldownChartCache; let i = index">
                            <div class="performerMainChart">
                                <app-score-drilldown-bar-chart [chartData]="data" (onGraphDataPointClick)="onGraphDataPointClick($event, 'performerChartData', i)"></app-score-drilldown-bar-chart>
                            </div>
                        </div> 
                    </div>  
                </div>
            </div>
        </div>
    </div>
</div>